import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  // Tutti gli inject() prima del primo await: dopo, il contesto di iniezione
  // non c'è più e Angular solleva NG0203 a ogni navigazione.
  const keycloak = inject(KeycloakService);
  const auth     = inject(AuthService);
  const router   = inject(Router);

  if (await keycloak.isLoggedIn()) {
    // Autenticato sul portale ma rifiutato da Saragraph: la shell non ha
    // niente da mostrare, la pagina di accesso negato spiega perché.
    if (auth.accessoNegato()) {
      return router.parseUrl('/accesso-negato');
    }
    return true;
  }
  await keycloak.login({ redirectUri: window.location.origin + state.url });
  return false;
};
